import EndpointsUrl from "../client/EndpointsUrl";
import axiosManager from '../client/AxiosManager/AxiosManager';
import { POST } from '../client/AxiosManager/AxiosManagerConstants';

export const DELETE_GALLERY_IMAGE_ID = 'DELETE_GALLERY_IMAGE_ID';
export const DELETE_GALLERY_IMAGE_ID_SUCCESS = 'DELETE_GALLERY_IMAGE_ID_SUCCESS';
export const DELETE_GALLERY_IMAGE_ID_ERROR = 'DELETE_GALLERY_IMAGE_ID_ERROR';

export function deleteImageEventGallery(photo) {
    let form_data = new FormData();
    form_data.append('id', photo.id);
    form_data.append('qquuid', photo.qquuid);

    return {
        type: DELETE_GALLERY_IMAGE_ID,
        payload: axiosManager(POST, EndpointsUrl.DELETE_GALLERY_IMAGE_ID, form_data)
    }
}

export function deleteImageEventGallerySuccess() {
    return {
        type: DELETE_GALLERY_IMAGE_ID_SUCCESS,
        payload: "Event photo successfully deleted."
    }
}

export function deleteImageEventGalleryError() {
    return {
        type: DELETE_GALLERY_IMAGE_ID_ERROR,
        payload: "Error while deleting event photo."
    }
}
